/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateBoardReportRequest
 */
export interface GenerateBoardReportRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateBoardReportRequest
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateBoardReportRequest
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateBoardReportRequest
     */
    reportPeriod?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateBoardReportRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the GenerateBoardReportRequest interface.
 */
export function instanceOfGenerateBoardReportRequest(value: object): value is GenerateBoardReportRequest {
    return true;
}

export function GenerateBoardReportRequestFromJSON(json: any): GenerateBoardReportRequest {
    return GenerateBoardReportRequestFromJSONTyped(json, false);
}

export function GenerateBoardReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateBoardReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'reportPeriod': json['reportPeriod'] == null ? undefined : json['reportPeriod'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function GenerateBoardReportRequestToJSON(json: any): GenerateBoardReportRequest {
    return GenerateBoardReportRequestToJSONTyped(json, false);
}

export function GenerateBoardReportRequestToJSONTyped(value?: GenerateBoardReportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profileId': value['profileId'],
        'frameworkSlug': value['frameworkSlug'],
        'reportPeriod': value['reportPeriod'],
        'effectTenantId': value['effectTenantId'],
    };
}

